import React from 'react'
import { withClientId } from 'hocs'
import { Row, Col, Table, DatePicker } from 'elements'
import { socketUri } from 'index'
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Icon } from "antd";
import { PageContentTitle } from 'components';
import * as actionsGlobal from '@/redux/new_store_structure/actions';

const COMPONENT_CSS_CLASSNAME = 'zone-attendance-report';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const columns = [
  {
    title: 'Name',
    dataIndex: 'name'
  },
  {
    title: 'Site ID',
    dataIndex: 'siteId'
  },
  {
    title: 'Status',
    dataIndex: 'status'
  },
  {
    title: 'Last Seen',
    dataIndex: 'lastSeen'
  }
];

class HolderAbsenceReport extends React.Component{
  handleAbsenceReportChange = (selectedDay) => {
    const { clientId, getHolderAbsenceReport } = this.props;
    const date = new Date(selectedDay);
    if (date.getDate() > new Date().getDate()) return;
    date.setHours(12,0,0,0);
    const day = date.toISOString();
    getHolderAbsenceReport({
      clientId,
      day
    });
  }

  render() {
    const { holderAbsenceReport, loading } = this.props;
    return(
      <Row type="flex" align="middle" gutter={12} style={{padding: '40px 20px'}}>
        <Col xs={24}>
          <PageContentTitle>
            Attendance Report
          </PageContentTitle>
          <br />
          <DatePicker
            style={{ width: '100%', marginBottom: 20 }}
            placeholder="Select a date"
            onChange={this.handleAbsenceReportChange}
            disabled={loading}
          />
          {!loading ? (holderAbsenceReport &&
            holderAbsenceReport.length > 0 && (
              <Table
                columns={columns}
                dataSource={holderAbsenceReport}
                scroll={{ x: 500 }}
                pagination={false}
              />
            )) : (
            <div
              style={{
                width: '100%',
                display: 'flex',
                height: 'calc(100vh - 350px)',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon type="loading" style={{ fontSize: '26px' }} />
            </div>
          )}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  holderAbsenceReport: ({ holderAbsenceReport }) => holderAbsenceReport.list,
  loading: ({ holderAbsenceReport }) => holderAbsenceReport.loading
});

const mapDispatchToProps = dispatch => ({
  getHolderAbsenceReport: params => dispatch(actionsGlobal.getHolderAbsenceReport(params))
});

export default compose(
  withClientId,
  connect(
    selector,
    mapDispatchToProps,
  ),
)(HolderAbsenceReport)



// WEBPACK FOOTER //
// ./src/smart-components/holder-absence-report/index.js